import React from 'react'
import { StreetOwnerResponse } from '../../../api/bridgingFinance/searchStreetOwnersList'
import '../SearchResultsTable.css'

export interface StreetOwnersListResultsTableProps {
  entries: StreetOwnerResponse[]
  title: string
  onRowClick?: (row: StreetOwnerResponse) => void
}

export const StreetOwnersListResultsTable: React.FC<
  StreetOwnersListResultsTableProps
> = ({ entries, title, onRowClick }) => {
  const handleClick = (erf: StreetOwnerResponse) => () => {
    if (onRowClick) onRowClick(erf)
  }

  return (
    <div className="kyc-bf-results-table-container">
      <h3 className="table-title">{title}</h3>
      <table>
        <thead>
          <tr style={{ height: '40px' }}>
            <th style={{ width: '70px' }}>Erf</th>
            <th style={{ width: '70px' }}>Street No</th>
            <th>Owners Name</th>
            <th style={{ width: '70px' }}>Extent</th>
            <th>Usage</th>
            {/* <th>Allotment</th>
          <th>CMA ID</th> */}
          </tr>
        </thead>
        <tbody>
          {entries.map((entry, index) => (
            <tr
              key={index}
              onClick={handleClick(entry)}
              style={{ height: '30px' }}
            >
              <td style={{ width: '70px' }}>{entry.erfNo}</td>
              <td style={{ width: '70px' }}>{entry.streetNo ?? '-'}</td>
              <td>{entry.owner}</td>
              <td style={{ width: '70px' }}>{entry.erfExtent}</td>
              <td>{entry.erfUsage}</td>
              {/* <td>{entry.allotment}</td>
            <td>{entry.cmaid}</td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
